



























































































































































import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import EventBus from '../../services/eventbus.service';
import moment from 'moment';
import {
  Getter,
  Mutation,
} from 'vuex-class';
import VueApexCharts from 'vue-apexcharts';
import WidgetService from '@/services/widget.service';

@Component({
  components: {
    VueApexCharts,
  },
})

export default class EventsWidget extends Vue {
  @Prop() private data!: any;
  @Prop() private container: any;
  private tableData: any = {};
  private visibleHeaders: any[] = [];
  private eventsTableMenu: any[] = [
    { title: 'Go to device details', navigation: `/devices/`, type: 'link'},
    { title: 'View event details', navigation: ``, type: 'dialog'},
  ];
  private filters: any = {};
  private checked: any = {};
  private filteredTableData: any = {};
  private selectedDevice: any = {};
  private defaultsApplied: boolean = false;
  private dialog: boolean = false;
  private dataTableHeight: number = 0;
  private counts: number = 0;
  private chartSeries: any[] = [];
  private chartOptions: any = {
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      },
      stacked: true,
      zoom: {
        enabled: false,
      },
      offsetX: -10,
    },
    colors: ['#d10000', '#FB8C00'],
    xaxis: {
      type: 'datetime',
      labels: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
    grid: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      x: {
        format: 'yyyy-MM-dd HH:mm',
      },
    },
    legend: {
      position: 'top',
    },
    title: {
      text: 'From the last 7 days',
      floating: true,
      offsetX: 5,
      style: {
        fontSize:  '12px',
        fontWeight:  'bold',
      },
    },
  };

  @Getter private widgetFilters!: string[];

  @Watch('data.payload.values.events')
  private onChange() {
    if (this.data.payload.values.events) {
      const copy = {...this.data.payload.values.events};

      Vue.set(this, 'filteredTable', copy);
      Vue.set(this, 'tableData', copy);
    }
  }
  @Watch('container')
  private onContainerResize() {
    if (this.container) {
      this.dataTableHeight = (this.container.$el as HTMLElement).offsetHeight - 64 - 100;
    }
  }

  private mounted() {
    this.applyDefaults();
    EventBus.$on('toggleCols', this.applyColumnChanges);
    EventBus.$on('filterByProject', this.filterBy);
    EventBus.$on('clearFilter', this.clearFilter);
    let tableCopy: any[] = [];
    if (!this.data || !this.data.payload || !this.data.payload.values || !this.data.payload.values.events) {
      return;
    }
    this.data.payload.values.events.length ? tableCopy = [...this.data.payload.values.events] : tableCopy = [];
    let headerCopy: any[] = [];
    this.data.payload.headers ? headerCopy = [...this.data.payload.headers] : headerCopy = [];
    Vue.set(this.tableData, 'rows', tableCopy);
    Vue.set(this.filteredTableData, 'rows', tableCopy);
    Vue.set(this.tableData, 'headers', this.visibleHeaders);
    Vue.set(this.filteredTableData, 'headers', headerCopy);

    this.initFilters();
  }

  private beforeDestroy() {
    EventBus.$off('toggleCols', this.applyColumnChanges);
    EventBus.$off('filterByProject', this.filterBy);
    EventBus.$off('clearFilter', this.clearFilter);
  }

  private getRowClass(item: any) {
    const rowClass: string = 'dashboard-table-font';
    return rowClass;
  }

  private initFilters() {
    let tableCopy: any[] = [];
    this.data.payload.values.events.length ? tableCopy = [...this.data.payload.values.events] : tableCopy = [];
    Vue.set(this.filteredTableData, 'rows', tableCopy);

    let filters = this.widgetFilters;
    filters = filters.filter((f: string) => f !== null);

    if (filters && filters.length) {
      const events = this.filteredTableData.rows.filter((d: any) => filters.find((filter: string) => d.projectName === filter));
      Vue.set(this.filteredTableData, 'rows', events);

      filters.map((f) => this.setChartData(f));
    }
  }

  private filterBy(filter: string) {
    this.filteredTableData.rows = this.filteredTableData.rows.filter((d: any) => d.projectName === filter);
    // assume filter is only the project
    this.setChartData(filter);
  }

  private clearFilter() {
    const tableCopy = [...this.data.payload.values.events];
    Vue.set(this.filteredTableData, 'rows', tableCopy);
    this.filters = {};
    this.checked = {};
    this.setChartData('');
  }

  private getTime(timestamp: string) {
    return {fromNow: moment(timestamp).fromNow(), timestamp: moment(timestamp).format('YYYY-MM-DD HH:mm:ss')};
  }

  private getSeverity(text: string) {
    switch (text) {
      case 'info':
        return 'success';
      case 'warning':
        return 'warning';
      case 'critical':
        return 'error';
      default:
        return 'success';
    }
  }

  private getType(type: string) {
    const event = {icon: '', title: ''};
    switch (type) {
      case 'seen':
        event.icon = 'mdi-eye-circle';
        event.title = 'seen';
        break;
      case 'predeploy':
        event.icon = 'mdi-arrow-up-circle';
        event.title = 'predeploy';
        break;
      case 'deviceAlert':
      case 'dataAlert':
        event.icon = 'mdi-alert-circle';
        event.title = 'alert';
        break;
      case 'downlink':
        event.icon = 'mdi-arrow-down-circle';
        event.title = 'downlink';
        break;
      case 'error':
        event.icon = 'mdi-minus-circle';
        event.title = 'error';
        break;
      case 'nodata':
        event.icon = 'mdi-close-circle';
        event.title = 'no data';
        break;
      case 'unrecognised':
        event.icon = 'mdi-help-circle';
        event.title = 'unrecognised';
        break;
      case 'reject':
        event.icon = 'mdi-cancel';
        event.title = 'reject';
        break;
      default:
        event.icon = 'mdi-circle-outline';
        event.title = 'none';
        break;
    }
    return event;
  }

  private applyDefaults() {
    if (this.data.payload && !this.defaultsApplied) {
      for (const header of this.data.payload.headers) {
        if (this.data.enabledFields.includes(header.value)) {
          this.visibleHeaders.push(header);
        }
      }
      this.defaultsApplied = true;
    }
    if (!this.widgetFilters.length) {
      this.setChartData('');
    }
  }

  private applyColumnChanges(col: any, toggled: string[], source: string, title: string, id: number) {
    if (source === 'events' && title === this.data.title) {
      const compared = this.data.payload.headers.filter((val: any) => toggled.includes(val.value));
      Vue.set(this, 'visibleHeaders', compared);

      if (id === this.data.id) {
        const headers = this.visibleHeaders.map((h: any) => h.value);
        this.data.enabledFields = headers;
      }
    }
  }

  private resetDialog() {
    this.dialog = false;
  }

  private truncateText(text: string, maxLength: number) {
    if (!text) {
      return null;
    }
    if (text.length <= maxLength) {
      return text;
    }
    return `${text.substring(0, maxLength)}...`;
  }

  private async setChartData( project: string) {
    const eventsCount = await WidgetService.getEventsCount(project);

    const currentDate = moment().format( 'YYYY-MM-DD hh:00' );
    const oneWeekAgoDate = moment().subtract( 7, 'days' ).format( 'YYYY-MM-DD hh:00' );
    if ( eventsCount.length === 0 || eventsCount[0].time > oneWeekAgoDate ) {
      eventsCount.unshift( { time: oneWeekAgoDate, critical: 0, warning: 0 } );
    }
    if ( eventsCount[0].time < currentDate ) {
      eventsCount.push( { time: currentDate, critical: 0, warning: 0 } );
    }
    Vue.set(this, 'counts', eventsCount.length);
    this.chartSeries = [
      {
        name: 'critical events',
        data: this.getSeriesData( eventsCount, 'critical' ),
      }, {
        name: 'warning events',
        data: this.getSeriesData( eventsCount, 'warning' ),
      },
    ];
  }

  private getSeriesData( events: any[], type: string ) {
    const seriesData = [];
    for ( const el of events ) {
      seriesData.push( {
        x: `${el.time} UTC`,
        y: el[type],
      } );
    }
    return seriesData;
  }
}
